/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_FindingsInputs */



/**
* | output |
* | --- |
* | "Findings: the channels, roles and join sources behind a change" |
*
* @param {Pricing_Compare_FindingsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_findings = /** @type {((inputs?: Pricing_Compare_FindingsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_FindingsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Находки: каналы, роли и источники входа, которые стоят за изменением")
	return /** @type {LocalizedString} */ ("Findings: the channels, roles and join sources behind a change")
});